import { formatDateTime, DATE_FORMATS } from '@belong/common';
import { Text } from '@belong/ui';

type Props = {
  completedOn?: string;
  label: string;
};

export function IntroCompletedOn({ completedOn, label }: Props) {
  if (!completedOn) return null;

  return (
    <div className="mb-0 mt-3xl text-center md:mb-lg md:mt-0">
      <Text fontWeight="semibold" variant="h3">
        {label}{' '}
        {formatDateTime({
          dateTime: completedOn,
          format: DATE_FORMATS.MONTH_DAY_SHORT,
        })}
      </Text>
    </div>
  );
}
